import React from 'react';
import { describeDataEnds } from '../utils/dataEnds';

// Shown under a page title when the account's newest sale is older than the
// selected window, so a past export reads as data rather than "No data yet".
export default function DataEndsNote({ dataEnds, period }: { dataEnds?: string | null; period: string }) {
  const text = describeDataEnds(dataEnds, period);
  if (!text) return null;
  return <p className="font-sans text-xs text-[#4A2D5E] mt-1.5">{text}</p>;
}
